import React, { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { cleanDepartmentOmbudsman } from '../../../redux/actions/f5-actions/department-ombudsman';
import ChooseSector, { Sector } from '../../../f5/sectors/ChooseSector';
import generalService from '../../../services/f5-services/generalService';

const DepartmentOmbudsman = () => {
    const [sectors, setSectors] = useState<Sector[]>([]);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(cleanDepartmentOmbudsman());
    }, [dispatch]);

    useEffect(() => {
        const getSectors = async () => {
            const res = await generalService.getSectorsCounter();
            // @ts-ignore
            setSectors(res?.counters ?? []);
        };

        getSectors();
    }, [setSectors]);

    return <ChooseSector
        sectors={sectors}
    />
};

export default DepartmentOmbudsman;
